import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { QueryExecution } from '../../types';
import LiveSearchResultsGridController from '../controller/LiveSearchResultsGridController';

export class LiveSearchResultsGridComponent extends BaseWebComponentElement {
  public controller: LiveSearchResultsGridController;
  private queryExecution: QueryExecution | null = null;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: LiveSearchResultsGridController,
    });
  }

  public getQueryExecution(): QueryExecution | null {
    return this.queryExecution;
  }

  public setQueryExecution(queryExecution: QueryExecution): void {
    this.queryExecution = queryExecution;
    this.rerenderGrid();
  }

  public unsetQueryExecution(): void {
    this.queryExecution = null;
    this.rerenderGrid();
  }

  public rerenderGrid() {
    this.controller.view.resetColumns();
    this.controller.render();
  }

  public renderExpiredResults() {
    if (this.queryExecution) {
      this.queryExecution.hasExpiredResults = true;
    }
    this.rerenderGrid();
  }
}
